var map = {
	"./product-1.png": 78,
	"./product-2.png": 79,
	"./product-3.png": 80,
	"./product-4.png": 81,
	"./product-5.png": 82,
	"./product-6.png": 83,
	"./product-7.png": 84,
	"./product-8.png": 85
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37;